// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"fX","label":"fY","downloadSize":"fZ","selectorWrapper":"f0","selected":"f1"};